import { render, staticRenderFns } from "./Workshops.vue?vue&type=template&id=3a58acb4&scoped=true&"
import script from "./Workshops.vue?vue&type=script&lang=ts&"
export * from "./Workshops.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58acb4",
  null
  
)

export default component.exports